import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';

const VendingMachineIcon = () => (
  <Svg width={28} height={28} viewBox="0 0 28 28" fill="none">
    <Path
      d="M4.5.75h15s1.5 0 1.5 1.5v18s0 1.5-1.5 1.5h-15s-1.5 0-1.5-1.5v-18S3 .75 4.5.75zM4.5 21.75v1.5M19.5 21.75v1.5M15 .75v21"
      stroke={
        getDescriber()?.pickupLocationInnerCircleBackgroundColor() ?? '#066DFF'
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="scale(1.16667)"
    />
    <Path
      d="M6 3.75h6v12H6v-12zM6 18.75h6M18 3.75v1.5M18 8.25v1.5M18 17.25v1.5"
      stroke={
        getDescriber()?.pickupLocationInnerCircleBackgroundColor() ?? '#066DFF'
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="scale(1.16667)"
    />
  </Svg>
);
export default VendingMachineIcon;
